import React, { Component } from 'react'

import Loading from '../../components/shared/Loading'

const LoadingOverlay = () => (
  <div className="loading-overlay">
    <Loading classes="loading" width="200" />
  </div>
)

export default LoadingOverlay
